export default () =>
  process.env.NODE_ENV === "development" || // eslint-disable-line no-undef
  window.location.host === "dev.unitutors.de";
